export default __webpack_public_path__ + "static/media/icone-ajuda-rapida.f859d45e.svg";